import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2ece6968&scoped=true"
import script from "./index.vue?vue&type=script&lang=tsx"
export * from "./index.vue?vue&type=script&lang=tsx"
import style0 from "./index.vue?vue&type=style&index=0&id=2ece6968&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ece6968",
  null
  
)

export default component.exports